const ACTIVATION_SUCCESS_MODAL_KEY = "activationSuccessModal";

type ActivationSuccessModalPayload = {
  offerName: string;
};

export const saveActivationSuccessModal = (offerName: string) => {
  window.sessionStorage.setItem(ACTIVATION_SUCCESS_MODAL_KEY, JSON.stringify({ offerName }));
};

export const getActivationSuccessModal = (): ActivationSuccessModalPayload | null => {
  const rawValue = window.sessionStorage.getItem(ACTIVATION_SUCCESS_MODAL_KEY);

  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue) as ActivationSuccessModalPayload;
  } catch {
    window.sessionStorage.removeItem(ACTIVATION_SUCCESS_MODAL_KEY);
    return null;
  }
};

export const clearActivationSuccessModal = () => {
  window.sessionStorage.removeItem(ACTIVATION_SUCCESS_MODAL_KEY);
};
